import React from "react";
import UseContext from "hooks/useContext";
import ActivityTemplate from "pages/missionTemplates/body/activity.template";
import PrerequisTemplate from "pages/missionTemplates/body/prerequis.template";
import LocationSalaryTemplate from "pages/missionTemplates/body/locationSalary.template";
import InfoTemplate from "pages/missionTemplates/body/info.template";
import ConfirmationTemplate from "pages/missionTemplates/body/confirmation.template";
import EndTemplate from "pages/missionTemplates/body/end.template";

const TemplateFormsCreate = ({
    mode,
    savedMissionTemplateDoc,
    editTemplateRouteId,
}) => {
    const { templatePage } = UseContext();
    const display = {
        1: <ActivityTemplate key="activity" />,
        2: <PrerequisTemplate key="prerequis" />,
        3: <LocationSalaryTemplate key="locationSalary" />,
        4: <InfoTemplate key="info" />,
        5: <ConfirmationTemplate key="confirmation" />,
        6: (
            <EndTemplate
                key="end"
                mode={mode}
                savedMissionTemplateDoc={savedMissionTemplateDoc}
                editTemplateRouteId={editTemplateRouteId}
            />
        ),
    };
    return <>{display[templatePage]}</>;
};

export default TemplateFormsCreate;
